import { createEntityAdapter } from '@ngrx/entity';
import { EspaceEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<EspaceEntityState>;

export const adapter = createEntityAdapter<EspaceEntityState>({
  selectId: o => o.idEspace
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const espaceFeatureKey = 'espace';
